import config from 'services/table/const';
import Action from './table.action';

let table = { ...config };

table.url = '/location';
table.filter = { type: 'point' }
table.columns = {
    name: {
        title: 'Lokasi',
        sortable: true,
        width: 150,
        component: (row) => {
            return (
                <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                        {row?.name}
                    </div>
                    <small className="info text-uppercase">
                        CP: {row?.contact_person}
                    </small>
                    <small className="info text-uppercase">
                        Phone: {row?.phone_number}
                    </small>
                </div>
            )
        },
    },
    address: {
        title: 'Alamat',
        sortable: false,
        width: 100,
        component: (row) => {
            return (
                <div className="table-col">
                    <small className="text-ellipsis info fw-semibold text-uppercase">   {row?.address}
                    </small>
                    <small className="info text-uppercase text-ellipsis">
                        {row?.region ? `${row?.region?.district_name}, ${row?.region?.regency_name}, ${row?.region?.province_name}` : null}
                    </small>
                </div>
            );
        },
    },
    action: {
        title: '',
        width: 70,
        class: 'text-end',
        component: (row) => {
            return <Action data={row} />;
        },
    },
};

export default table;
